import { HStack, Icon, Menu, MenuButton, MenuGroup, MenuItem, MenuList, Text } from "@chakra-ui/react";
import { FaCalendarAlt, FaCheck, FaChevronDown, FaExchangeAlt } from "react-icons/fa";

export default function SinglePeriodMode({
  currentPeriods,
  currentValue,
  isRTL,
  onSelectPeriod,
  onSwitchToRange,
  t,
}) {
  const currentPeriod = currentPeriods.find((period) => period.value === currentValue);

  return (
    <Menu>
      <MenuButton
        w="full"
        variant="outline"
        size="sm"
        textAlign={isRTL ? "right" : "left"}
        h="40px"
      >
        <HStack spacing={2} w="full" justify={isRTL ? "flex-end" : "flex-start"}>
          {isRTL && <Icon as={FaChevronDown} />}
          <Icon as={FaCalendarAlt} />
          <Text noOfLines={1} flex={1}>
            {currentPeriod?.label || t("reports.select", "اختر")}
          </Text>
          {!isRTL && <Icon as={FaChevronDown} />}
        </HStack>
      </MenuButton>
      <MenuList maxH="350px" overflowY="auto">
        <MenuGroup title={isRTL ? "📅 اختيار فترة محددة" : "📅 Select a Period"}>
          <MenuItem onClick={onSwitchToRange} icon={<FaExchangeAlt />} color="purple.600" fontWeight="medium">
            {isRTL ? "نطاق مخصص (من - إلى)" : "Custom Range (From - To)"}
          </MenuItem>
          {currentPeriods.map((period) => (
            <MenuItem
              key={period.value}
              onClick={() => onSelectPeriod(period.value)}
              fontWeight={period.value === currentValue ? "bold" : "normal"}
              bg={period.value === currentValue ? "blue.50" : "white"}
            >
              <HStack w="full" justify="space-between">
                <Text>{period.label}</Text>
                {period.value === currentValue && (
                  <FaCheck color="var(--chakra-colors-blue-500)" />
                )}
              </HStack>
            </MenuItem>
          ))}
        </MenuGroup>
      </MenuList>
    </Menu>
  );
}
